import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzButtonModule, NzDatePickerModule, NzModalModule, NzSelectModule } from 'ng-zorro-antd';
import { SharedModule } from '../shared/shared.module';
import { ChartsModule } from 'ng2-charts';
import { RouterModule } from '@angular/router';
import { CoreModule } from '../core/core.module';
import { DashboardReportsComponent } from './dashboard-reports.component';
import { MatAutocomplete, MatAutocompleteModule, MatPaginatorModule, MatProgressBarModule, MatProgressSpinnerModule, MatSortModule, MatTableModule } from '@angular/material';
import { OverviewComponent } from './tables/overview/overview.component';
import { LeadsByProductComponent } from './tables/leads-by-product/leads-by-product.component';
import { ReceivedLeadByAgentsComponent } from './tables/received-lead-by-agents/received-lead-by-agents.component';
import { DistributionQueueModule } from '../distribution-queue/distribution-queue.module';
@NgModule({
  declarations: [
    DashboardReportsComponent,
    OverviewComponent,
    LeadsByProductComponent,
    ReceivedLeadByAgentsComponent
  ],
  imports: [
    RouterModule,
    CommonModule,
    CoreModule,
    SharedModule,
    NzDatePickerModule,
    NzModalModule,
    NzButtonModule,
    NzSelectModule,
    ChartsModule,
    MatTableModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatSortModule,
    MatProgressSpinnerModule,
    DistributionQueueModule,
    MatAutocompleteModule
  ],
  exports: [
    DashboardReportsComponent
  ],
  entryComponents: [
    
  ]
})
export class DashboardReportsModule { }
